document.addEventListener("DOMContentLoaded", function () {

const popup = document.getElementById("enquiryPopup");

document.querySelectorAll(".open-popup").forEach(btn => {

btn.addEventListener("click", function(e){

e.preventDefault();

popup.classList.add("active");

const service=this.dataset.service;

if(service){

document.getElementById("popupService").value=service;

}

});

});

document.querySelector(".popup-close").onclick=function(){

popup.classList.remove("active");

}

popup.addEventListener("click",function(e){

if(e.target===popup){

popup.classList.remove("active");

}

});

});